import { useCallback, useEffect, useRef } from 'react';
import { Selector, Flex, NumericInput, Pane, Text } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import { Blocker } from '@leverege/molten/views';
import P from '@leverege/promise';
import InputGroup from './InputGroup';
import C from '../Constants';
import KeyWarrantyLengthEditor from '../../pairing/KeyWarrantyLengthEditor';

// adding a comment to force deploy in staging
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RecovrKeysInformation(props) {
  const {
    vehicle,
    actions,
    keysSalesPrice,
    qtyOfTags,
    knowTags,
    onChange: pOnChange,
    keys: saleKeys,
    location,
    tagBlueprint,
    keysWarranty
  } = props;
  const extendedWarrantyEnabled = Attributes.get('location.extendedWarrantyEnabled', 'location', location?.data);
  const deferred = useRef(P.deferred());
  const options = [{
    name: 'Yes',
    value: true
  }, {
    name: 'No',
    value: false
  }];
  const qtyOfTag = [{
    name: 1,
    value: 1
  }, {
    name: 2,
    value: 2
  }, {
    name: 3,
    value: 3
  }];
  const onQtyChange = evt => {
    pOnChange({
      data: 'qtyOfTags',
      value: evt.value
    });
  };
  const onChange = evt => {
    pOnChange({
      data: 'knowTags',
      value: evt.value
    });
  };
  const onKeyWarrantyLengthChange = useCallback(evt => {
    pOnChange({
      data: 'keysWarranty',
      value: {
        warrantyLength: evt.value
      }
    });
  }, [pOnChange]);
  const onKeysChange = useCallback(evt => {
    pOnChange({
      data: 'keys',
      value: {
        ...saleKeys,
        [evt.data]: evt.value
      }
    });
  }, [pOnChange, saleKeys]);
  useEffect(() => {
    const getKeys = async () => {
      try {
        const {
          items: keys
        } = await GlobalState.dispatch(actions.child('keys').list());
        pOnChange({
          data: 'keys',
          value: keys.reduce((prev, key) => {
            // eslint-disable-next-line no-param-reassign
            prev[key.id] = {
              key,
              sell: !knowTags,
              tag: key.data.tag,
              tagId: key.data.tag?.data?.serialNumber,
              tagSaleStatus: knowTags ? C.TAG_SALE_STATUS.VERIFIED : C.TAG_SALE_STATUS.UNVERIFIED
            };
            return prev;
          }, {})
        });
        deferred.current.resolve();
      } catch (err) {
        deferred.current.reject(err);
      }
    };
    getKeys();
  }, [vehicle, actions, knowTags]);
  const render = useCallback(() => {
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "RecovR Tags"
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowL",
        align: "center",
        children: [/*#__PURE__*/_jsx("img", {
          width: 80,
          height: 80,
          alt: "RecovR Tags",
          src: "https://storage.googleapis.com/recovr-ui-assets/recovr-tag.png"
        }), /*#__PURE__*/_jsx(Flex, {
          variant: "colM",
          children: /*#__PURE__*/_jsx(Text, {
            variant: "bodySmall",
            children: "RecovR Tags can be sold with each of the keys and are a great way to locate lost keys."
          })
        })]
      }), /*#__PURE__*/_jsx(InputGroup, {
        eventData: "keysSalesPrice",
        onChange: pOnChange,
        editor: NumericInput,
        editorProps: {
          min: 0,
          float: true
        },
        value: keysSalesPrice,
        title: "RecovR Tags Sales Price"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "bodySmallBold",
        children: "Quantity of RecovR Tags in Sale *"
      }), /*#__PURE__*/_jsx(Selector, {
        variant: "timeZone"
        // toggleVariant="detailSecondary"
        ,
        values: qtyOfTag,
        value: qtyOfTags,
        onChange: onQtyChange
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodySmallBold",
          children: "Do you know all of the RecovR Tag IDs in this sale? *"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "If you know some but not all Tag IDs, select \"No\". Customers will be able to pair their Tags on the app."
        })]
      }), /*#__PURE__*/_jsx(Selector, {
        variant: "timeZone"
        // toggleVariant="detailSecondary"
        ,
        values: options,
        value: knowTags,
        onChange: onChange
      }), extendedWarrantyEnabled && /*#__PURE__*/_jsx(InputGroup, {
        eventData: "keysWarranty",
        editor: KeyWarrantyLengthEditor,
        onChange: onKeyWarrantyLengthChange,
        value: keysWarranty?.warrantyLength,
        title: "Keys Warranty Length"
      })]
    });
  }, [keysSalesPrice, saleKeys, extendedWarrantyEnabled, onKeyWarrantyLengthChange, keysWarranty?.warrantyLength, actions, location, tagBlueprint, onKeysChange]);
  return /*#__PURE__*/_jsx(Blocker, {
    hooks: [{
      execute: () => {
        return deferred.current;
      }
    }],
    render: render,
    matchContext: {},
    context: props
  });
}